/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class Assign extends Route {
  @service declare appService: $TSFixMe;
  @service declare router: RouterService;

  async beforeModel() {
    if (!this.appService.app.canAccessSalesforceCasesRedesign) {
      this.router.transitionTo('apps.app.standalone.deploy.salesforce.cases');
    }
  }
}
